<!-- Подробности титулов документа для tooltip компактного табличного flow. -->
<template>
  <span class="edo-flow-cell-tooltip">
    <strong class="edo-flow-cell-tooltip__title">
      {{ documentLabel }} · {{ completedCount }} из {{ groups.length }} титулов
    </strong>

    <span class="edo-flow-cell-tooltip__list">
      <span
        v-for="group in groups"
        :key="group.key"
        class="edo-flow-cell-tooltip__row"
      >
        <span
          class="edo-flow-cell-tooltip__marker"
          :class="`edo-flow-cell-tooltip__marker--${group.tone}`"
          aria-hidden="true"
        ></span>
        <span class="edo-flow-cell-tooltip__description">
          <strong>{{ group.label }}</strong>
          <span v-if="group.actor">{{ group.actor }}</span>
        </span>
        <span class="edo-flow-cell-tooltip__status">{{ group.statusLabel }}</span>
      </span>
    </span>
  </span>
</template>

<script>
export default {
  name: "EdoDocumentFlowCellTooltip",

  props: {
    documentLabel: {
      type: String,
      required: true,
    },
    groups: {
      type: Array,
      required: true,
    },
    completedCount: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style scoped>
.edo-flow-cell-tooltip,
.edo-flow-cell-tooltip__list,
.edo-flow-cell-tooltip__description {
  display: flex;
  flex-direction: column;
}

.edo-flow-cell-tooltip {
  width: 228px;
  max-height: min(280px, calc(100vh - 32px));
  overflow-y: auto;
  gap: 10px;
}

.edo-flow-cell-tooltip__title {
  color: #303545;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.35;
}

.edo-flow-cell-tooltip__list {
  gap: 8px;
}

.edo-flow-cell-tooltip__row {
  display: grid;
  grid-template-columns: 10px minmax(0, 1fr) auto;
  gap: 8px;
  align-items: start;
}

.edo-flow-cell-tooltip__marker {
  width: 10px;
  height: 10px;
  margin-top: 3px;
  border-radius: 3px;
  background: #c4cad6;
}

.edo-flow-cell-tooltip__marker--success {
  background: var(--color-green);
}

.edo-flow-cell-tooltip__marker--warning {
  background: #f59e0b;
}

.edo-flow-cell-tooltip__marker--danger {
  background: var(--color-danger);
}

.edo-flow-cell-tooltip__description {
  min-width: 0;
  gap: 1px;
  color: #4b5060;
  font-size: 12px;
  line-height: 1.35;
}

.edo-flow-cell-tooltip__description strong {
  color: #303545;
  font-weight: 600;
}

.edo-flow-cell-tooltip__status {
  max-width: 92px;
  color: #6d7280;
  font-size: 11px;
  line-height: 1.35;
  text-align: right;
}
</style>
